var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressReleaseNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "#1B1B39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8516 13.9977L17.2083 13.6474C17.3993 13.8419 17.3993 14.1535 17.2083 14.348L16.8516 13.9977ZM11.6839 9.44795C11.4904 9.25091 11.4933 8.93434 11.6904 8.74087C11.8874 8.54741 12.204 8.55032 12.3974 8.74736L11.6839 9.44795ZM12.3974 19.248C12.204 19.445 11.8874 19.4479 11.6904 19.2544C11.4933 19.061 11.4904 18.7444 11.6839 18.5474L12.3974 19.248ZM16.4948 14.348L11.6839 9.44795L12.3974 8.74736L17.2083 13.6474L16.4948 14.348ZM17.2083 14.348L12.3974 19.248L11.6839 18.5474L16.4948 13.6474L17.2083 14.348Z",
    fill: "#F7F7FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressReleaseNext);
export default __webpack_public_path__ + "static/media/pressReleaseNext.aa05bf9bc18960dbe9bdf9d8cea9a10b.svg";
export { ForwardRef as ReactComponent };